import AvatarsList from './AvatarsList';
export default AvatarsList;
